var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndicater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4525 8L11.0241 10H8.54719L8.97576 8H11.4525ZM5.5 2C4.11929 2 3 3.11929 3 4.5V13.5C3 14.8807 4.11929 16 5.5 16H14.5C15.8807 16 17 14.8807 17 13.5V4.5C17 3.11929 15.8807 2 14.5 2H5.5ZM9.10487 5.0112C9.37488 5.06906 9.54686 5.33486 9.489 5.60487L9.19005 7H11.6667L12.0103 5.39539C12.0682 5.12537 12.3339 4.95336 12.604 5.01119C12.874 5.06902 13.046 5.3348 12.9882 5.60482L12.6893 7H13.5C13.7761 7 14 7.22386 14 7.5C14 7.77614 13.7761 8 13.5 8H12.4752L12.0468 10H13C13.2761 10 13.5 10.2239 13.5 10.5C13.5 10.7761 13.2761 11 13 11H11.8326L11.489 12.6043C11.4312 12.8744 11.1654 13.0464 10.8954 12.9885C10.6254 12.9307 10.4534 12.6649 10.5112 12.3949L10.8099 11H8.3329L7.989 12.6049C7.93114 12.8749 7.66535 13.0469 7.39534 12.989C7.12533 12.9311 6.95334 12.6654 7.0112 12.3953L7.3102 11H6.5C6.22386 11 6 10.7761 6 10.5C6 10.2239 6.22386 10 6.5 10H7.52449L7.95306 8H7C6.72386 8 6.5 7.77614 6.5 7.5C6.5 7.22386 6.72386 7 7 7H8.16735L8.5112 5.39534C8.56906 5.12533 8.83486 4.95334 9.10487 5.0112Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicater);
export default __webpack_public_path__ + "static/media/indicater.00b8194f.svg";
export { ForwardRef as ReactComponent };